import type { Component } from 'solid-js'
import type { CommunityTimeSeriesData } from '../../../features/engagement/domain/models/community'
import { ChartContainer, ChartLegend, useChartWithLegend, useLegendState } from '../charts'
import { getCommunityChartOptions, COMMUNITY_LEGEND_ITEMS, COMMUNITY_INITIAL_LEGEND_STATE } from './CommunityChart.vm'

interface CommunityChartProps {
  data: CommunityTimeSeriesData[]
}

const CommunityChart: Component<CommunityChartProps> = (props) => {
  let chartRef: HTMLDivElement | undefined

  const { state: legendState, toggle } = useLegendState(COMMUNITY_INITIAL_LEGEND_STATE)

  useChartWithLegend({
    data: () => props.data,
    chartRef: () => chartRef,
    legendState,
    buildOptions: (data, legend) => getCommunityChartOptions(data, legend)
  })

  return (
    <ChartContainer hasData={props.data && props.data.length > 0}>
      <ChartLegend items={COMMUNITY_LEGEND_ITEMS} activeKeys={legendState()} onToggle={toggle} class="mb-4" />
      <div ref={chartRef} />
    </ChartContainer>
  )
}

export default CommunityChart
